var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 84,
    viewBox: "0 0 60 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484F79",
    d: "M50.8 27.4C50.8 15.581 41.219 6 29.4 6 17.581 6 8 15.581 8 27.4c0 5.844 2.345 11.138 6.142 15h-.004s.024.022.063.062l.096.097c.924.957 5.608 6.168 6.064 13.841h18.078c.456-7.673 5.14-12.884 6.064-13.84l.096-.098.063-.062h-.004c3.797-3.862 6.142-9.156 6.142-15",
    transform: "translate(-252 -328) translate(252 328) rotate(-20 29.4 31.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeWidth: 1.5,
    d: "M50.393 58.038l-19.448 7.079c-1.064.387-2.242-.162-2.63-1.227l-1.058-2.909c-.388-1.065.161-2.242 1.226-2.63l19.448-7.078c1.065-.388 2.242.161 2.63 1.226l1.059 2.91c.387 1.064-.162 2.242-1.227 2.63",
    transform: "translate(-252 -328) translate(252 328)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeWidth: 1.5,
    d: "M50.765 70.248l-12.256 4.46c-2.013.733-4.239-.305-4.972-2.317l-2.64-7.256 19.545-7.114 2.641 7.256c.733 2.012-.305 4.238-2.318 4.97M38.999 74.53l.23.634c.553 1.518 2.232 2.301 3.75 1.748l5.778-2.103c1.518-.552 2.301-2.23 1.749-3.75l-.231-.633-11.276 4.104z",
    transform: "translate(-252 -328) translate(252 328)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M39.316 54.195l-5.479-15.052c-.58-1.594.242-3.358 1.838-3.94 1.594-.58 3.358.243 3.939 1.838.58 1.595-.242 3.359-1.837 3.94l-9.272 3.374c-1.595.58-3.359-.242-3.94-1.837-.58-1.595.243-3.359 1.838-3.94 1.595-.58 3.359.243 3.94 1.838l5.478 15.051",
    transform: "translate(-252 -328) translate(252 328)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLightbulb);
export default __webpack_public_path__ + "static/media/img-lightbulb.2e4af99dd674aac9c33375c878b533d2.svg";
export { ForwardRef as ReactComponent };